<template>
    <footer class="footer" v-if="!$store.state.is_loading">
        <div class="inner">
            <ul>
                <li class="logo">
                    <h1 class="footerLogo">
                        <router-link to="/">
                            <svg-icon name="logo" />
                        </router-link>
                    </h1>
                </li>
                <li class="social">
                    <a href="https://uk.linkedin.com/company/manea-kella" target="_blank">LinkedIn</a><br />
                    <a href="https://www.instagram.com/maneakella/" target="_blank">Instagram</a>
                </li>
                <li class="address">
                    39–41 Lonsdale Road<br />
                    London NW6 6RA<br /><br />
                </li>
                <li class="contact">
                    <p>
                        +44 (0) 20 8935 5003<br />
                        <a href="mailto:info@maneakella.com">info@maneakella.com</a>
                    </p>
                </li>
                <li class="riba">
                    <img src="/wp-content/uploads/2024/12/CharteredPracticeblacktypelogoeps.svg"
                        alt="RIBA Logo" />
                </li>
                <li class="bcorp">
                    <img src="/wp-content/uploads/2024/12/2018-B-Corp-Logo-Black-L-2.svg"
                        alt="BCORP" />
                </li>
            </ul>
        </div>
    </footer>
</template>

<script>
export default {
    name: "Footer",

    // data() {
    //     return {
    //         footer_html: "",
    //     };
    // },

    methods: {
        top() {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        },
    },

    // mounted() {
    //     this.$ajax.get("/footer-options").then((res) => {
    //         this.footer_html = res.data.html;
    //     });
    // },
};
</script>
<style lang="scss">
.footer {
    margin-bottom: 0;
    
    padding: 0 0 var(--padding-x4);
    margin-left: var(--padding-x2);
    margin-right: var(--padding-x2);

    .inner{
        padding: 0;
    }

    .footerLogo svg {
        width: 10vw;
        max-height: 3vw;
    }

    ul {
        border-top: 1px solid var(--gray);
        padding-top: var(--padding-x4);
        display: flex;
        flex-wrap: wrap;
        margin: 0 !important;

        .logo {
            width: 61%;
            margin-bottom: var(--padding);
            order: 1;
        }

        .social {
            padding-top: var(--padding);
            width: 61%;
            margin-bottom: var(--padding);
            order: 4;
        }

        .address {
            width: 27%;
            margin-bottom: var(--padding);
            order: 2;
        }

        .contact {
            padding-top: var(--padding);
            width: 27%;
            margin-bottom: var(--padding);
            order: 5;
        }

        .riba {
            order: 3;
            width: 11%;

            img {
                width: 7.5vw;
                max-width: 100%;
            }
        }

        .bcorp {
            padding-top: var(--padding);
            order: 6;
            width: 11%;

            img {
                width: 2vw;
                max-height: 5.5rem;
            }
        }
    }

    @media screen and (max-width: 768px) {
        margin-bottom: 0;
        margin-left: var(--padding);
        margin-right: var(--padding);
        padding-top: 0;

        .inner {
            padding-left: 0;
            padding-right: 0;


            ul {
                display: grid;
                grid-template-columns: 65% 35%;
                grid-template-rows: 24vw repeat(3, 14vw);
                gap: 0;
                margin: 0 var(--padding);
                padding-bottom: 0;
                padding-top: var(--padding-x3);

                .logo {
                    width: 100%;
                    height: 5vw;
                    margin-bottom: var(--padding-x2);
                    margin-top: var(--padding);
                    order: 1;
                    text-align: center;
                    grid-column: span 2;
                    font-size: var(--large-size);

                    svg {
                        margin: auto;
                        width: 40vw;
                    }
                }

                .social {
                    width: 100%;
                    padding-top: 0;
                    margin-bottom: 0;
                    order: 6;
                    font-size: var(--small-size);
                    display: flex;

                    :nth-child(1) {
                        padding-right: 15%;
                    }
                }

                .address {
                    width: 100%;
                    margin-bottom: 0;
                    order: 2;
                    font-size: var(--small-size);
                }

                .contact {
                    width: 100%;
                    padding-top: 0;
                    margin-bottom: 0;
                    order: 4;
                    font-size: var(--small-size);
                }

                .riba {
                    width: 100%;
                    order: 3;

                    img {
                        width: 100%;
                    }
                }

                .bcorp {
                    width: 100%;
                    padding-top: 0;
                    order: 5;
                    grid-row: span 2;

                    img {
                        width: auto;
                        height: 18vw;
                        max-height: 18vw;
                    }
                }
            }
        }
    }
}
</style>
